import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-04/lesson-18/task-01";

const task: Slide = {
  titleHtml:
    "Knowing that the amplitude of the displacement can be obtained by dividing the velocity of<br>the diaphragm by the angular frequency  ω, what is the shape of the filter equivalent to the displacement?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
